<template>
  <div class="footer" >
    <div class="footer-container">
    <div class="footer-brand">
      <img class="keep-hue" :src="footerLogo" draggable="false" alt="" />
    </div>
    <div class="footer-content">
      <dl class="footer-quick" v-if="quickLink.length > 0">
        <dt>快速入口：</dt>
        <dd>
          <template v-for="(link, index) in quickLink">
            <a :key="index" :href="link.url" target="_blank">{{ link.name }}</a>
          </template>
        </dd>
      </dl>
      <dl class="footer-friend-link" v-if="links.length > 0">
        <dt>友情链接：</dt>
        <dd>
          <template v-for="(link, index) in links">
            <a :key="index" :href="link.url" target="_blank">{{ link.name }}</a>
          </template>
        </dd>
      </dl>
      <div class="footer-divider"></div>
      <div class="footer-contact">
        <span v-html="telePhone"></span>
        <span v-html="address"></span>
      </div>
      <div class="footer-copyright" v-html="copyright"></div>
    </div>
    <div class="footer-motto">
      <img class="keep-hue" :src="motto" draggable="false" alt="" />
    </div>
    </div>
  </div>
</template>
<script>
  import { getSystemVisitSave } from "@/api/user";
export default {
  name: "FooterNav",
  props:{
    telePhone:{
      default: ''
    } ,
    address: {
      default: ''
    },
    quickLink:{
        type:Array,
        default: ()=>[]
      },
    links:{
      type:Array,
      default: ()=>[]
    },
    copyright: {
      default: ""
    },
    motto:{
      default: ''
    },
    footerLogo:{
      default: ''
    },
    footerBackground:{
      default: ''
    }
  },
  methods: {
    //点击友情链接
    openLinks(link) {
      window.open(link);
    }
  },
  mounted(){
    this.$nextTick(()=> {
      setTimeout(()=>{
        // 记录网站访问次数
        getSystemVisitSave();
      }, 1000);
    })
  }
};
</script>
<style lang="scss">
  @import "@/styles/variables.scss";

  $footer-height: 230px;
  .footer {
    position: relative;
    width: 100%;
    padding: 51px 0px;
    overflow: hidden;
    background-color: $color-primary;
    background-image: linear-gradient(to left,rgba(0, 0, 0, 0.7),rgba(0, 0, 0, 0.7)),url(~@/assets/footer-bg.png);
    box-sizing: border-box;

    &-background {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: bottom;
      background-color: rgba(0, 0, 0, 0.7);
      background-image: url(~@/assets/footer-bg.png)
    }
    &-container {
      width: 1680px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      @include portalMedia;
    }

    &-brand {
      position: relative;
      padding-right: 43px;
      margin-right: 40px;
      border-right: 1px solid rgba(255, 255, 255, 0.2);

      > img {
        display: block;
        width: 100%;
        max-width: 118px;

      }
    }

    &-content {
      position: relative;
      flex: 1;
      font-size: 12px;
      > dl {
        margin: 0;
        overflow: hidden;
      }

      .footer-quick,
      .footer-friend-link {
        > dt {
          float: left;
          margin-right: 16px;
          line-height: 12px;
          color: rgba(255, 255, 255, 0.8);
        }

        > dd {
          display: flex;
          flex-wrap: wrap;
          color: rgba(255, 255, 255, 0.8);
          line-height: 12px;
          overflow: hidden;

          > a {
            padding-right: 16px;
            margin-right: 16px;
            margin-bottom: 20px;

            &:not(:last-child) {
              border-right: 1px solid rgba(255, 255, 255, 0.2);
            }
          }
        }
      }

      .footer-divider {
        position: relative;
        height: 1px;
        background-color: rgba(255, 255, 255, 0.2);
      }

      .footer-contact {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding-top: 1px;
        padding-bottom: 1px;
        font-size: 12px;
        line-height: 12px;
        color: rgba(255, 255, 255, 0.8);
        overflow: hidden;
      }

      .footer-contact > span {
        white-space: pre-wrap;
        margin-right: 30px;
        margin-top: 20px;
      }

      .footer-copyright {
        position: relative;
        margin-top: 20px;
        font-size: 12px;
        line-height: 12px;
        color: rgba(255, 255, 255, 0.6)
      }
    }

    &-motto {
      position: relative;
      max-width: 256px;
      margin-left: 49px;
      > img {
        display: block;
        width: 100%;
      }
    }
  }

</style>
